// removed by extract-text-webpack-plugin
module.exports = {"menu":"menu_2o3hY","center":"center_1kzIK","bottom":"bottom_2ZLis","cantEdit":"cantEdit_1NzTE","needsEdit":"needsEdit_3IZ97"};


//////////////////
// WEBPACK FOOTER
// ./app/components/menu/styles.scss
// module id = 457
// module chunks = 1